'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _models = require('./models/models.js');

var _models2 = _interopRequireDefault(_models);

var _bzGallery = require('./directives/bzGallery.js');

var _bzGallery2 = _interopRequireDefault(_bzGallery);

var _bzLoadingContainer = require('./directives/bzLoadingContainer.js');

var _bzLoadingContainer2 = _interopRequireDefault(_bzLoadingContainer);

var _bzAttribute = require('./directives/bzAttribute.js');

var _bzAttribute2 = _interopRequireDefault(_bzAttribute);

var _bzDot = require('./directives/bzDot.js');

var _bzDot2 = _interopRequireDefault(_bzDot);

var _toTop = require('./directives/toTop.js');

var _toTop2 = _interopRequireDefault(_toTop);

var _bzSticky = require('./directives/bzSticky.js');

var _bzSticky2 = _interopRequireDefault(_bzSticky);

var _default = require('./filters/default.js');

var _default2 = _interopRequireDefault(_default);

var _trust = require('./filters/trust.js');

var _trust2 = _interopRequireDefault(_trust);

var _trustUrl = require('./filters/trustUrl.js');

var _trustUrl2 = _interopRequireDefault(_trustUrl);

var _plain = require('./filters/plain.js');

var _plain2 = _interopRequireDefault(_plain);

var _BaseGlobalCtrl = require('./controllers/BaseGlobalCtrl.js');

var _BaseGlobalCtrl2 = _interopRequireDefault(_BaseGlobalCtrl);

var _config = require('./config.js');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var appName = 'base';

var _module = angular.module(appName, ['ui.bootstrap', 'ngTouch', 'ngSanitize', 'slick', 'sun.scrollable', 'ap.fotorama', _models2.default]);

_module.constant('API_URL', '/api').factory('$exceptionHandler', function ($log) {
    return function myExceptionHandler(exception, cause) {
        $log.error(exception, cause);
    };
});

// directives


_module.directive('bzGallery', _bzGallery2.default).directive('bzLoadingContainer', _bzLoadingContainer2.default).directive('bzAttribute', _bzAttribute2.default).directive('bzDot', _bzDot2.default).directive('toTop', _toTop2.default).directive('bzSticky', _bzSticky2.default);

// filters


_module.filter('default', _default2.default).filter('trust', _trust2.default).filter('trustUrl', _trustUrl2.default).filter('plain', _plain2.default);

// controllers


_module.controller('BaseGlobalCtrl', _BaseGlobalCtrl2.default);

// config


_module.config(_config2.default).constant('API', '/api/rest.php').run(function ($rootScope) {
    $('.splash').css('display', 'none');

    $rootScope.imageUrl = function (image, queryString) {
        if (!angular.isObject(image)) return;

        if (angular.isObject(queryString)) {
            var qs = '';
            if (queryString.width) {
                qs += 'w=' + queryString.width + '&';
            }
            if (queryString.height) {
                qs += 'h=' + queryString.height + '&';
            }
            if (queryString.autocrop) {
                qs += 'zs=1';
            }
            queryString = qs;
        }

        return '/image/' + encodeURIComponent(image.id) + '/' + encodeURIComponent(image.name) + (queryString ? '?' + queryString : '');
    };
});

exports.default = appName;


// WEBPACK FOOTER //
// ./app/base/base.js